import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useSetCleanroomFlowVersion = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading,
    isError,
    isSuccess,
    mutate,
    reset,
  } = useMutation(
    ['set-cleanroom-flow-version', orgId],
    async ({
      cleanRoomId, crFlowId, version, ...payload
    }) => (
      axiosInstance.put(
        flow(orgId).setCleanroomFlowVersion(cleanRoomId, crFlowId, version),
        payload,
      )
    ),
    {
      onSuccess: () => (
        dispatch(showAlert({
          message: 'Flow current version has been updated.',
          type: 'success',
        }))
      ),
      onError: (error) => dispatch(showAlert({
        message: error.response.data.message,
        type: 'error',
      })),
    },
  );
  return {
    isLoading,
    isError,
    isSuccess,
    mutate,
    reset,
  };
};
